/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Agent_Policy_Number_RangeInputs */



/**
* | output |
* | --- |
* | "Enter a whole number from {min} to {max}." |
*
* @param {Agent_Policy_Number_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_number_range = /** @type {((inputs: Agent_Policy_Number_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Number_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Geben Sie eine ganze Zahl von ${i?.min} bis ${i?.max} ein.`)
	return /** @type {LocalizedString} */ (`Enter a whole number from ${i?.min} to ${i?.max}.`)
});